export default __webpack_public_path__ + "static/media/TemplateBudgetForecast.26ee8cc0.xlsx";